import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import initialState from './updateProfB1FormInitialState';
import axios from 'axios';
import {
  _setIsProfB1DataLoaded,
  _setCountyOfLastLegalResidenceId,
  _setDateReceivedCDC,
  _setLengthOfTermInYrsAndMos,
  _setSecondStrike,
  _setCommitmentOffenses,
  _setExpectedPrisonReleaseDate,
  _setControllingDischargeDate,
  _setComments,
  _setReleaseDate,
  _setControllingDchDate,
  _setEPRD,
  _setRRD,
  _setPED,
  _setCDD,
  _setCDD_MAX,
  _setHighControlSupervision,
  _setH11590NarcoticRegistration,
  _setPC296ViolentOrSeriousOffenderNotification,
  _setCity,
  _setParoleRegion,
  _setHistoryOfConvictions,
  _setRSuffixInCentralFile,
  _setRSuffixExplination,
  _setP290SexRegistration,
  _setP457_1ArsonRegistration,
  _setLengthOfTermInYrs,
  _setLengthOfTermInMos,
} from './profB1FormActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getProfB1Form = createAsyncThunk(
  'stop/getProfB1Form',
  async (params) => {
    const { profB1TabUrl, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(profB1TabUrl, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const profB1Slice = createSlice({
  name: 'stop/profB1',
  initialState,
  reducers: {
    setIsProfB1DataLoaded: _setIsProfB1DataLoaded,
    setCountyOfLastLegalResidenceId: _setCountyOfLastLegalResidenceId,
    setDateReceivedCDC: _setDateReceivedCDC,
    setLengthOfTermInYrsAndMos: _setLengthOfTermInYrsAndMos,
    setSecondStrike: _setSecondStrike,
    setCommitmentOffenses: _setCommitmentOffenses,
    setExpectedPrisonReleaseDate: _setExpectedPrisonReleaseDate,
    setControllingDischargeDate: _setControllingDischargeDate,
    setComments: _setComments,
    setReleaseDate: _setReleaseDate,
    setControllingDchDate: _setControllingDchDate,
    setEPRD: _setEPRD,
    setRRD: _setRRD,
    setPED: _setPED,
    setCDD: _setCDD,
    setCDD_MAX: _setCDD_MAX,
    setHighControlSupervision: _setHighControlSupervision,
    setH11590NarcoticRegistration: _setH11590NarcoticRegistration,
    setPC296ViolentOrSeriousOffenderNotification:
      _setPC296ViolentOrSeriousOffenderNotification,
    setCity: _setCity,
    setParoleRegion: _setParoleRegion,
    setHistoryOfConvictions: _setHistoryOfConvictions,
    setRSuffixInCentralFile: _setRSuffixInCentralFile,
    setRSuffixExplination: _setRSuffixExplination,
    setP290SexRegistration: _setP290SexRegistration,
    setP457_1ArsonRegistration: _setP457_1ArsonRegistration,
    setLengthOfTermInYrs: _setLengthOfTermInYrs,
    setLengthOfTermInMos: _setLengthOfTermInMos,
  },
  extraReducers: {
    [getProfB1Form.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  setIsProfB1DataLoaded,
  setCountyOfLastLegalResidenceId,
  setDateReceivedCDC,
  setLengthOfTermInYrsAndMos,
  setSecondStrike,
  setCommitmentOffenses,
  setExpectedPrisonReleaseDate,
  setControllingDischargeDate,
  setComments,
  setReleaseDate,
  setControllingDchDate,
  setEPRD,
  setRRD,
  setPED,
  setCDD,
  setCDD_MAX,
  setHighControlSupervision,
  setH11590NarcoticRegistration,
  setPC296ViolentOrSeriousOffenderNotification,
  setCity,
  setParoleRegion,
  setHistoryOfConvictions,
  setRSuffixInCentralFile,
  setRSuffixExplination,
  setP290SexRegistration,
  setP457_1ArsonRegistration,
  setLengthOfTermInYrs,
  setLengthOfTermInMos,
} = profB1Slice.actions;

export default profB1Slice.reducer;
